import { useEffect, useState, useCallback } from 'react'; // Removed React
//  \u25B6 play button
//  \u23F8 stop button
// sequenceActive = '\u{1F534}', sequenceInactive = '\u2B1B'
const useTitleActivity = (isActive = 1, sequenceActive = '\u23F3', sequenceInactive = '') => {
  const [title, setTitle] = useState(document.title);

  //  Provides consistent string across entire hook
  function getInsertedSequence(sequence) {
    return sequence === '' ? '' : `${sequence} `;
  }

  const cleanTitle = useCallback(
    (currentTitle) => currentTitle // Moved to same line
      .replace(new RegExp(`${getInsertedSequence(sequenceActive)}|${getInsertedSequence(sequenceInactive)}`, 'g'), ''),
    [sequenceActive, sequenceInactive],
  ); // Dependencies for cleanTitle

  useEffect(() => {
    document.title = title;
  }, [title]);

  useEffect(() => {
    let newTitle = cleanTitle(title);
    if (isActive === 1) {
      newTitle = `${getInsertedSequence(sequenceActive)}${newTitle}`;
    } else if (isActive === 0) {
      newTitle = `${getInsertedSequence(sequenceInactive)}${newTitle}`;
    }

    setTitle(newTitle);

    return () => {
      document.title = cleanTitle(title);
    };
  }, [isActive, sequenceActive, sequenceInactive, cleanTitle, title]); // Added cleanTitle and title
};

export default useTitleActivity;
